import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import customAxios from "lib/axios";
import useAppDispatch from "hooks/useAppDispatch";
import { show } from "store/reducers/notifications.reducer";
import { useTranslation } from "react-i18next";

const AutoLogin = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [t] = useTranslation(["login"]);

  useEffect(() => {
    const autoLogin = async () => {
      const searchParams = new URLSearchParams(location.search);
      const userHash = searchParams.get('userHash');

      if (!userHash) {
        dispatch(show({ type: "error", msg: t("noToken")}));
        return history.push('/');
      }

      try {
        const response = await customAxios.post("autoLogin", {
            hashUserId: userHash
          });

        if (response.data.success) {
          localStorage.setItem("user_id", response.data.user_id);
          localStorage.removeItem("user_email");
          dispatch(show({ type: "success", msg: t("sesionOK")}));
          window.location.href = '/';
        } else {
          dispatch(show({ type: "error", msg: t("invalidToken")}));
          return history.push('/');
        }
      } catch (error) {
        dispatch(show({ type: "error", msg: t("invalidToken")}));
        return history.push('/');
      }
    };

    autoLogin();
  }, [location, history]);

  return <div>{t("procesingAcces")}</div>;
};

export default AutoLogin;
